import ReactWebChat from 'botframework-webchat';
import { usePostStartConversationActivity, useFetchDirectLineToken, useSetTokenMessageListener } from './hooks';
import useCreateDirectLine from './hooks/useCreateDirectLine';
import { Spinner } from './components';
import { WebChatStyleOptions } from './styles/WebChatStyleOptions';
import './styles/webChatCustomStyle.css';
import './styles/app.css';

function App() {
  const { token: fetchedToken } = useFetchDirectLineToken();
  const { token: messageToken } = useSetTokenMessageListener();
  const token = messageToken ?? fetchedToken;
  const { directLine } = useCreateDirectLine(token);
  usePostStartConversationActivity(token, directLine);

  if (!token || !directLine) {
    return <Spinner />;
  }

  return (
    <ReactWebChat
      directLine={directLine}
      styleOptions={WebChatStyleOptions}
    />
  );
}

export default App;
